import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useCLTypes() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarTiposLenteContacto.php", {
      token: userData.token,
    });
    setList([...response.map((e) => ({ id: e.id, text: e.descripcion }))]);
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
